import { Flex, type FlexProps, Text } from '@radix-ui/themes';
import type React from 'react';

type InputFieldWrapperProps = FlexProps & {
  children: React.ReactNode;
  label?: string;
  helpText?: string;
  errorText?: string;
  optional?: boolean;
  action?: React.ReactNode;
};

function InputFieldWrapper({
  children,
  label,
  helpText,
  errorText,
  optional = false,
  action = null,
  ...rest
}: InputFieldWrapperProps) {
  return (
    <Flex
      direction='column'
      gap='1'
      {...rest}
    >
      {(label || optional || action) && (
        <Flex justify='between'>
          <Flex gap='2'>
            {label && (
              <Text
                size='2'
                as='label'
              >
                {label}
              </Text>
            )}
            {optional && (
              <Text
                size='2'
                as='label'
                color='gray'
              >
                (Optional)
              </Text>
            )}
          </Flex>
          {action}
        </Flex>
      )}
      {children}
      {helpText && !errorText && (
        <Text
          size='1'
          color='gray'
          as='label'
        >
          {helpText}
        </Text>
      )}
      {errorText && (
        <Text
          size='1'
          color='red'
          as='label'
        >
          {errorText}
        </Text>
      )}
    </Flex>
  );
}

export default InputFieldWrapper;
